export default function CooperationSection() {
  const services = [
    {
      icon: 'ri-advertisement-line',
      title: '品牌广告投放',
      description: 'CPM/CPC/CPA多种结算方式，精准触达目标用户群体，提供品牌专区、信息流广告、内容定制等多种合作方案',
    },
    {
      icon: 'ri-user-star-line',
      title: 'KOL内容合作',
      description: '连接5万+优质创作者，覆盖影视、科技、生活、美食等垂直领域，提供定制化内容营销解决方案',
    },
    {
      icon: 'ri-share-forward-line',
      title: '全渠道内容分发',
      description: '一次创作，30+平台同步分发，覆盖微信、微博、抖音、快手、B站、头条等主流社交媒体',
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: '数据分析服务',
      description: '提供阅读量、互动量、用户画像、传播路径等多维度数据报告，助力内容策略优化和投放效果评估',
    },
    {
      icon: 'ri-film-line',
      title: '影视内容合作',
      description: '提供影视宣发、影评内容定制、观影团活动等一站式影视营销服务，助力作品实现口碑与票房双丰收',
    },
    {
      icon: 'ri-building-line',
      title: '企业品牌传播',
      description: '为企业提供品牌故事定制、企业文化建设、危机公关内容等全方位品牌传播解决方案',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs bg-secondary-100 text-secondary-700 rounded-full mb-3 whitespace-nowrap">
            合作方案
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            全方位服务体系
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            为品牌、创作者和企业提供一站式内容传播解决方案
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((service, index) => (
            <div
              key={index}
              className="p-6 rounded-lg bg-background-100 border border-background-200/60 hover:border-primary-200 transition-all group cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                <i className={`${service.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-800 mb-2">{service.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-white rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            了解更多合作方案
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}